<template>
  <div
    v-if="isQueuedReports"
    class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content"
    @click.self="close"
  >
    <div
      class="relative w-full lg:w-[83%] max-h-screen bg-[#f8f8f8] p-[40px] overflow-auto"
    >
      <button
        class="absolute right-12 top-12 cursor-pointer z-10"
        type="button"
        @click="close"
      >
        <span class="mdi text-xl mdi-close"></span>
      </button>
      <div
        class="w-full pb-2 flex flex-col justify-start items-start gap-[15px]"
      >
        <h2 class="text-[#353535] text-[20px] leading-[28px] font-semibold">
          Queued Reports
        </h2>
        <div
          class="flex xs:flex-col xl:flex-row xs:justify-start xl:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 xl:items-center"
        >
          <p class="text-[#353535] text-[14px] leading-[20px] font-medium">
            View all queued reports
          </p>
          <div
            class="flex gap-1 sm:gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center"
          >
            <button
              @click="viewFilter"
              class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
            >
              <span class="">
                <img src="/assets/icon/sort.svg" alt="" />
              </span>
              Filters
            </button>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table p-0 m-0 dataTable no-footer text-nowrap">
          <thead>
            <tr>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                Name of the Report
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                Category
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                Requested By
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                Created
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                Status
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                Completed
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                Start Date
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                End Date
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                Type
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody class="bg-white">
            <tr v-if="loading">
              <td colspan="10" class="text-center">
                <div
                  class="text-center"
                  style="padding-top: 100px; padding-bottom: 50px"
                >
                  <span
                    class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                    style="font-size: 8rem"
                  ></span>
                  <h3
                    class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                    style="padding-bottom: 100px"
                  >
                    Please wait
                  </h3>
                </div>
              </td>
            </tr>
            <tr
              v-for="item in ReportItems"
              :key="item.id || item.rowNum"
              v-else
            >
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                {{ item.reportName }}
              </td>
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                {{ item.category }}
              </td>
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                {{ item.requestedBy }}
              </td>
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                {{ formatDate(item.created) }}
              </td>
              <td
                class="text-[14px] font-normal capitalize leading-[16.94px] text-[#353535]"
              >
                <span
                  :class="{
                    'text-yellow-600': item.status === 'Pending',
                    'text-red-600': item.status === 'Failed',
                    'text-green-600': item.status === 'Completed',
                  }"
                  class="font-medium"
                >
                  {{ item.status }}
                </span>
              </td>
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                {{ item.completed ? formatDate(item.completed) : "-" }}
              </td>
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                {{ item.startDate ? formatDate(item.startDate) : "-" }}
              </td>
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                {{ item.endDate ? formatDate(item.endDate) : "-" }}
              </td>
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                {{ item.type }}
              </td>
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                <button
                  v-if="item.status === 'Completed' && item.link"
                  @click="downloadReport(item)"
                  class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[16px] py-[8px] flex items-center gap-[5px] outline-none focus:outline-none hover:bg-[#1e52d1]"
                >
                  <span class="feather icon-download text-white"></span>
                  Download
                </button>
                <span v-else class="text-[#96a0b5]">-</span>
              </td>
            </tr>
            <tr v-if="!ReportItems.length && !loading">
              <td colspan="10">
                <div class="text-center">No matching records</div>
              </td>
            </tr>
          </tbody>
        </table>
        <Pagination
          :limit="pageSize"
          :count="pageCount"
          :page="page"
          :itemsCount="count"
          @changePage="gotoPage"
          @changeLimit="changeLimit"
        />
      </div>
    </div>
    <div class="modal fade py-1" id="mod-filter" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Filter
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="mb-[16px]">
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Start Date</label
              >
              <div>
                <input
                  type="date"
                  :max="maxDate"
                  placeholder="Select a date"
                  v-model="filter.dateStart"
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none focus:outline-none"
                />
              </div>
              <div class="my-[16px]">
                <label
                  class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                  >End Date</label
                >
                <input
                  type="date"
                  :max="maxDate"
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none focus:outline-none"
                  placeholder="Select a date"
                  v-model="filter.dateEnd"
                />
              </div>
            </div>
            <div class="mb-[16px]">
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Report Name</label
              >
              <div>
                <select
                  v-model="filter.reportName"
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none focus:outline-none"
                >
                  <option value="">All Reports</option>
                  <option v-for="name in reportNames" :key="name" :value="name">
                    {{ name }}
                  </option>
                </select>
              </div>
            </div>
            <div>
              <label
                class="text-[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Report Category</label
              >
              <div>
                <select
                  v-model="filter.category"
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none focus:outline-none"
                >
                  <option value="">All Categories</option>
                  <option
                    v-for="cat in reportCategories"
                    :key="cat"
                    :value="cat"
                  >
                    {{ cat }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[#96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="border-[#96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click="reset"
            >
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[#2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click="applyFilters"
            >
              {{ loading ? "Loading..." : "Search" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import Select2 from "@/components/Select2";
import { helper } from "@/helper";
import moment from "moment";
import Pagination from "../Pagination.vue";

export default {
  name: "QueuedReports",
  components: {
    Select2,
    Pagination,
  },
  props: ["close"],
  created() {
    this.loadEnums();
    this.getQueuedReports();
  },
  data() {
    return {
      filter: {
        dateStart: "",
        dateEnd: "",
        reportName: "",
        category: "",
      },
      isBusy: false,
      loading: false,
      ReportItems: [],
      isQueuedReports: true,
      count: 0,
      page: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      maxDate: "",
      reportNames: [],
      reportCategories: [],
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  mounted() {
    this.maxDate = helper.preventFutureDateSelection();
  },
  methods: {
    reset() {
      this.page = 1;
      this.filter = {
        dateStart: "",
        dateEnd: "",
        reportName: "",
        category: "",
      };
    },
    viewFilter() {
      $("#mod-filter").modal("show");
    },
    applyFilters() {
      this.page = 1;
      this.getQueuedReports();
    },
    loadEnums() {
      this.$http
        .get("/Reports/queuedReports")
        .then((res) => {
          if (res.body && res.body.reportNames) {
            this.reportNames = res.body.reportNames;
          }
          if (res.body && res.body.reportCategories) {
            this.reportCategories = res.body.reportCategories;
          }
        })
        .catch((err) => {});
    },

    getQueuedReports() {
      this.isBusy = true;
      this.loading = true;
      const params = new URLSearchParams();
      params.append("page", this.page - 1);
      params.append("pageSize", this.pageSize);
      if (this.filter.dateStart) {
        params.append(
          "createdDateStart",
          moment(this.filter.dateStart).format("YYYY-MM-DD 00:00:00")
        );
      }
      if (this.filter.dateEnd) {
        params.append(
          "createdDateEnd",
          moment(this.filter.dateEnd).format("YYYY-MM-DD 23:59:59")
        );
      }
      if (this.filter.reportName) {
        params.append("reportName", this.filter.reportName);
      }
      if (this.filter.category) {
        params.append("reportCategory", this.filter.category);
      }
      if (this.user.parentId) {
        params.append("parentId", this.user.parentId);
      }
      const url = `/Reports/queuedReports?${params.toString()}`;
      this.$http
        .get(url)
        .then((res) => {
          this.ReportItems = res.body.data || [];
          this.pageSize = res.body.pageSize || this.pageSize;
          this.count = res.body.count || 0;
          this.pageCount =
            res.body.totalPages || Math.ceil(this.count / this.pageSize) || 0;
          this.hasPrev = this.page > 1;
          this.hasNext = this.page < this.pageCount;

          if (res.body.reportNames && res.body.reportNames.length > 0) {
            this.reportNames = res.body.reportNames;
          }
          if (
            res.body.reportCategories &&
            res.body.reportCategories.length > 0
          ) {
            this.reportCategories = res.body.reportCategories;
          }

          if (this.reportNames.length === 0 && this.ReportItems.length > 0) {
            const uniqueNames = [
              ...new Set(
                this.ReportItems.map(
                  (item) => item.reportName || item.name
                ).filter(Boolean)
              ),
            ];
            this.reportNames = uniqueNames.sort();
          }
          if (
            this.reportCategories.length === 0 &&
            this.ReportItems.length > 0
          ) {
            const uniqueCategories = [
              ...new Set(
                this.ReportItems.map((item) => item.category).filter(Boolean)
              ),
            ];
            this.reportCategories = uniqueCategories.sort();
          }

          this.loading = false;
          $("#mod-filter").modal("hide");
          this.isBusy = false;
        })
        .catch((err) => {
          console.error("Error fetching queued reports:", err);
          $("#mod-filter").modal("hide");
          this.isBusy = false;
          this.loading = false;
        });
    },

    formatDate(date) {
      if (!date) return "-";
      return moment(date).format("lll");
    },

    formatDateForFilename(date) {
      if (!date) return "";
      return moment(date).format("YYYY_MM_DD");
    },

    downloadReport(item) {
      if (!item.link || item.status !== "Completed") {
        return;
      }
      const typeMap = {
        excel: "xlsx",
        csv: "csv",
        pdf: "pdf",
        xlsx: "xlsx",
        xls: "xls",
      };
      const completedDate = this.formatDateForFilename(item.completed);
      const reportName = (item.reportName || item.name || "Report").replace(
        /\s+/g,
        "_"
      );
      const fileTypeRaw = (item.type || "pdf").toLowerCase();
      const fileExtension = typeMap[fileTypeRaw] || fileTypeRaw;
      const filename = `${reportName}_${completedDate}.${fileExtension}`;
      let downloadUrl = item.link;
      if (item.link.startsWith("http://") || item.link.startsWith("https://")) {
        downloadUrl = item.link;
      } else if (item.link.startsWith("/v1/")) {
        downloadUrl = item.link.replace(/^\/v1/, "");
      } else if (item.link.startsWith("/")) {
        downloadUrl = item.link;
      } else {
        downloadUrl = `/Reports/queuedReports/${item.link}/download`;
      }
      this.isBusy = true;
      this.$http
        .get(downloadUrl, { responseType: "blob" })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.data.type || "application/octet-stream",
            })
          );

          const link = document.createElement("a");
          link.href = fileURL;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(fileURL);
          this.isBusy = false;
        })
        .catch((err) => {
          console.error("Error downloading report:", err);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = filename;
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.isBusy = false;
        });
    },

    gotoPage(page) {
      this.page = page;
      this.getQueuedReports();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.page = 1;
      this.getQueuedReports();
    },
  },
};
</script>
